// extracted by mini-css-extract-plugin
export var center = "_3l-2";
export var clickableRow = "_3l-5";
export var expandedRow = "_3l-7";
export var hoverable = "_3l-4";
export var left = "_3l-1";
export var right = "_3l-3";
export var row = "_3l-0";
export var selectedRow = "_3l-6";
export var summaryRow = "_3l-8";